import axios from 'axios';
import qs from 'qs';

import { API_URL } from '@source/constants/api';
import { TRegionKey } from '@source/interface';
import { WHOLESALE_AXIOS_USER_AUTH } from './UserProfile';

const Service = {
  getConfigOptions: (country: TRegionKey, configs: Record<string, any>) => {
    const queryString = qs.stringify(configs);
    const configOptionsAPI = API_URL(country).configOptions;

    return axios.get(`${configOptionsAPI}?${queryString}`);
  },

  getInspectionLocation: (country: TRegionKey, provinceId?: number | null) => {
    const queryString = qs.stringify({ province_id: provinceId || undefined });
    const { regionPathUrl } = API_URL(country);

    return axios.get(`${regionPathUrl}/inspection-location?${queryString}`);
  },

  createB5Ticket: ({
    country,
    payload,
    isAuthenticated,
  }: {
    country: TRegionKey;
    payload: Record<string, unknown>;
    isAuthenticated?: boolean;
  }) => {
    const b5TicketAPIPath = API_URL(country).b5Ticket;

    if (isAuthenticated) {
      return WHOLESALE_AXIOS_USER_AUTH.post(`${b5TicketAPIPath}`, payload);
    }

    return axios.post(`${b5TicketAPIPath}`, payload);
  },
};

export default Service;
